import { IFlowState } from "@/stores/flow-store";
import { Tag } from "./tag";

export enum FlowStatus {
  DRAFT = 'DRAFT',
  ACTIVE = 'ACTIVE',
  PAUSED = 'PAUSED',
  ERROR = 'ERROR'
}

export interface Flow {
  id: number;
  createdAt: string;
  updatedAt: string;
  name: string;
  description: string;
  workflow: IFlowState['workflow'];
  runCount: number;
  finishedCount: number;
  sendMessageCount: number;
  status: FlowStatus;
  conversionRate: number;
  lastRun: Date | null;
  tags: Tag[];
}
